/**
 * Billing's one line to the "Prices vs last bid" report (owner, Nov 1 2026): how many yards bill something other
 * than what their last accepted bid promised, and a tap to the report. Reads only — the report changes nothing.
 */
import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { Scale } from 'lucide-react';
import { api } from '../services/api';

export default function PriceCheckCard() {
  const { data } = useQuery<{ words: string; counts: { mismatched: number } }>('price-check', () => api.get('/price-check').then(r => r.data), { staleTime: 30_000 });
  const n = data?.counts?.mismatched || 0;
  return (
    <div className={`card p-4 flex flex-wrap items-center justify-between gap-3 ${n ? 'border-amber-300' : ''}`}>
      <div className="flex items-start gap-3 min-w-0">
        <Scale className={`h-5 w-5 mt-0.5 flex-shrink-0 ${n ? 'text-amber-700' : 'text-gray-400'}`} aria-hidden />
        <div className="min-w-0">
          <p className="font-semibold text-gray-900">Prices vs last bid</p>
          <p className="text-sm text-gray-600">{data ? data.words : 'Yards whose mow price is not what their last accepted bid promised.'}</p>
        </div>
      </div>
      <Link to="/price-check" className="press inline-flex items-center px-3 py-2 text-sm font-semibold rounded-xl border border-gray-300 bg-white hover:bg-gray-50">Open the report</Link>
    </div>
  );
}
